import * as React from "react"
import { Route, Switch } from "react-router-dom"
import { Browse } from "./Browse/Browse"
import { Categories } from "./Category/Category"
import { Downloads } from "./Downloads/Downloads"
import { Playlist } from "./Playlist/Playlist"
import { Search } from "./Search/Search"
import { Curated } from "./Curated/Curated"
import { Compare } from "./Compare/Compare"

export const Statistics: React.FC = () => {
    return <Switch>
        <Route path='/statistics/downloads' component={Downloads} />
        <Route path='/statistics/category' component={Categories} />
        <Route path='/statistics/search' component={Search} />
        <Route path='/statistics/browse' component={Browse} />
        <Route path='/statistics/playlist' component={Playlist} />
        <Route path='/statistics/curated' component={Curated} />
        <Route path='/statistics/compare' component={Compare} />
    </Switch>
}


// WEBPACK FOOTER //
// ./src/pages/Statistics/index.tsx